// -------------------------------------------------------------------------- //
// Style
// -------------------------------------------------------------------------- //

require(__dirname + '/../scss/front.scss');

// -------------------------------------------------------------------------- //
// Javascript
// -------------------------------------------------------------------------- //

require(__dirname + '/vendor.js');
require(__dirname + '/components/components.js');
